import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const FormContainer = styled(Stack)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
});

export const InputFieldsContainer = styled(Box)({
  display: 'flex',
  height: '240px',
  flexDirection: 'column',
  justifyContent: 'space-between',
  marginTop: '48px',
  marginBottom: '48px',
});

export const ErrorText = styled(Typography)({
  marginBottom: '16px',
  textAlign: 'center',
});

export const ReturnToSignInText = styled(Typography)({
  margin: '32px',
  textAlign: 'center',
  cursor: 'pointer',
});
